/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
export default {
  fetchAccounts (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`account/${payload.company_id}/all`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAccount (context, accountId) {
    return new Promise((resolve, reject) => {
      axios.get(`account/${accountId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createAccount (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('account', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAccount (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`account/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteAccount (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`account/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAccountVisibility (context, payload) {
    return axios.patch(`account/${payload.id}/visibility`, { is_hidden: payload.is_hidden })
  },
  getAccountLevel (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`account/${payload.company_id}/level/${payload.no_level}`)
        .then((resp) => {
          resolve(resp)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getSubAccount (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`account/${payload.company_id}/sub-account?ids=${payload.account_ids.join('%2C')}`)
        .then((resp) => {
          resolve(resp)
        }).catch((err) => {
          reject(err)
        })
    })
  }
}
